export const formatTraits = (traits: any) => {
    const traitsRecuded = traits.reduce((acc: any, trait: any) => {
        const [key, value] = trait?.value?.split(":")
        return { ...acc, [key]: acc[key] ? [...acc[key], value] : [value] }
    }, {})
    return traitsRecuded
}